import type { StaticTextResource } from '../keys'

export const fil: StaticTextResource = {
  'schedule.dueToday': 'Hanggang {{time}} ngayon',
  'schedule.dueTomorrow': 'Hanggang {{time}} bukas',
  'schedule.durationRange':
    '{{start}} - {{end}} (ika-{{currentDay}} araw / {{days}} araw)',
  'editReport.defaultPageName': 'Pahina {{n}}',
  'editReport.defaultSectionName': 'Seksyon',
  'editReport.defaultRepeatSectionName': 'Paulit-ulit na seksyon',
}
